import React, { useEffect, useState, useContext } from 'react';
import WidgetOpeningProps from 'modules/shared/widgets/components/widget-opening/widget-opening.props';
import WidgetOpeningCarouselBasic from 'modules/shared/widgets/components/widget-opening/components/widget-opening-carousel-basic';
import { TeApiContext } from '@ecommerce/nest-ssr/common';
import classNames from 'classnames';
import { CarouselProps } from 'react-multi-carousel';

import './widget-opening.scss';

const WidgetOpening: React.FC<WidgetOpeningProps> = ({ config, data }) => {
    const [WidgetOpeningCarousel, setWidgetOpeningCarousel] = useState<React.ComponentType<CarouselProps>>(() => WidgetOpeningCarouselBasic);
    const numberOfItems = 1;
    const autoPlay = config.autoPlay;

    const api = useContext(TeApiContext);

    if (api === null) {
        throw new Error('Invalid API context');
    }

    const isMobile = api.getDevice() === 'mobile';

    useEffect(() => {
        import('react-multi-carousel').then(mod => {
            setWidgetOpeningCarousel(() => mod.default);
        });
    }, []);

    const responsive = {
        desktop: {
            breakpoint: { max: 3000, min: 1 },
            items: numberOfItems
        }
    };

    return (
        <div
            className={classNames({
                'widget-opening': true,
                'widget-opening-m': isMobile
            })}
        >
            <div className="widget-opening__slider">
                <WidgetOpeningCarousel
                    responsive={responsive}
                    swipeable={isMobile}
                    draggable={isMobile}
                    slidesToSlide={numberOfItems}
                    showDots={true}
                    renderDotsOutside={false}
                    arrows={false}
                    autoPlay={autoPlay}
                    infinite={autoPlay}
                    className="w-opening-carousel__list"
                    itemClass={`w-opening-carousel__list__item w-${numberOfItems}`}
                >
                    {data.banner.map((item, idx) => (
                        <a
                            className="link"
                            key={`${idx}`}
                            href={item.url}
                            target={item.target}
                            rel={item.target === '_blank' ? 'nofollow noopener' : ''}
                        >
                            <img
                                className="image"
                                src={item.img}
                                alt={item.alt}
                            />
                        </a>
                    ))}
                </WidgetOpeningCarousel>
            </div>
            <div className="widget-opening__boxes">
                {data.boxes.map((item, idx) => (
                    <a
                        className={`item item--${idx + 1}`}
                        key={`${idx}`}
                        href={item.url}
                        target={item.target}
                        rel={item.target === '_blank' ? 'nofollow noopener' : ''}
                    >
                        <img
                            className="widget-opening__boxes__link__image"
                            src={item.img}
                            alt={item.alt}
                        />
                    </a>
                ))}
            </div>
        </div>
    );
};

export default WidgetOpening;
